import { FC, useEffect, useState } from 'react';
import type { Dispatch } from 'redux';
import { connect, useDispatch } from 'react-redux';

import { accountOrganizationsGet } from 'CorePackage/AccountModule/actions/accountActions';
import { getAccountOrganizationsStatus } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { AccountStatusesEnum } from 'CorePackage/AccountModule/enums/AccountStatusesEnum';
import { getUserInfo } from 'AuthPackage/MainModule/selectors/authSelectors';
import { IUserInfo } from 'APIPackage/AuthModule/interfaces/IUserInfo';

import { RootActions } from '../types/RootActions';
import { IRootState } from '../interfaces/IRootState';

interface IUserOrganizationsCheckStoreProps {
  userInfo: IUserInfo | undefined;
  isOrganizationStatus: AccountStatusesEnum;
}

const UserOrganizationsCheckWithoutStore: FC<IUserOrganizationsCheckStoreProps> = ({
  children,
  isOrganizationStatus,
  userInfo,
}) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [isCheck, setIsChecked] = useState(false);

  useEffect(() => {
    if (userInfo && isOrganizationStatus === AccountStatusesEnum.IDLE) {
      dispatch(accountOrganizationsGet());
    }
  }, [dispatch, isOrganizationStatus, userInfo]);

  useEffect(() => {
    if (isOrganizationStatus === AccountStatusesEnum.SUCCEEDED || !userInfo) {
      setIsChecked(true);
    }
  }, [isOrganizationStatus, userInfo]);

  if (!isCheck) {
    return null;
  }

  return <>{children}</>;
};

const mapStateToProps = (state: IRootState): IUserOrganizationsCheckStoreProps => ({
  userInfo: getUserInfo(state),
  isOrganizationStatus: getAccountOrganizationsStatus(state),
});

export const UserOrganizationsCheck = connect(mapStateToProps)(UserOrganizationsCheckWithoutStore);
